import { Routes, Route } from "react-router-dom";
import { NewsData } from "../../../components/news/types";
import NewsPage from "../NewsPage";
import NewsList from "../../../components/news/NewsList";

const TopicsRoute = (props: {news_data: NewsData}) => {
    return (
    <>
        <Routes>
            <Route
                path=""
                element={
                    <NewsList
                        news_data={props.news_data}
                        defaultSelectedCategory="topics"
                    />
                }
            />
            <Route 
                path={"/:newsId"}
                element={
                    <NewsPage
                        newsList={props.news_data.topics}
                        category="topics"
                    />
                }
            />
        </Routes>
    </>
    );
}

export default TopicsRoute;